const prefix = 'CUSTOMER_';

export const FETCH_ABSENCE_REQUEST = `${prefix}FETCH_ABSENCE_REQUEST`;
export const FETCH_ABSENCE_RECEIVE = `${prefix}FETCH_ABSENCE_RECEIVE`;
export const FETCH_ABSENCE_ERROR = `${prefix}FETCH_ABSENCE_ERROR`;

export const FETCH_MEMOS_REQUEST = `${prefix}FETCH_MEMOS_REQUEST`;
export const FETCH_MEMOS_RECEIVE = `${prefix}FETCH_MEMOS_RECEIVE`;
export const FETCH_MEMOS_ERROR = `${prefix}FETCH_MEMOS_ERROR`;

export const GET_MY_CUSTOMERS_REQUEST = `${prefix}GET_MY_CUSTOMERS_REQUEST`;
export const GET_MY_CUSTOMERS_RECEIVE = `${prefix}GET_MY_CUSTOMERS_RECEIVE`;
export const GET_MY_CUSTOMERS_ERROR = `${prefix}GET_MY_CUSTOMERS_ERROR`;

export const POST_ABSENCE_REQUEST = `${prefix}POST_ABSENCE_REQUEST`;
export const POST_ABSENCE_ERROR = `${prefix}POST_ABSENCE_ERROR`;

export const CLEAR_CUSTOMER_DATA = `${prefix}CLEAR_DATA`;
